import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { initializeAnalytics, initializeLogger, ThemeProvider } from '@chilecompra/react-kit'

import {
  REACT_APP_ENVIRONMENT,
  REACT_APP_GOOGLE_ANALYTICS_KEY,
  REACT_APP_GOOGLE_TASK_MANAGER_ID,
  REACT_APP_HOTJAR_ID,
  REACT_APP_HOTJAR_SNIPPET_VERSION
} from './config/settings/environment.config'
import { storeSingleton } from './config/store/store.config'
import { SnackbarProvider } from './containers/SnackbarProvider'
import { Routing } from './Routing'

initializeAnalytics({
  gaKey: REACT_APP_GOOGLE_ANALYTICS_KEY,
  gtmId: REACT_APP_GOOGLE_TASK_MANAGER_ID,
  hotjarId: REACT_APP_HOTJAR_ID,
  hotjarSV: REACT_APP_HOTJAR_SNIPPET_VERSION
})

initializeLogger({
  environment: REACT_APP_ENVIRONMENT === 'prod' ? 'prod' : 'dev'
})

const element = document.getElementById('__root')
const root = createRoot(element)
const store = storeSingleton()

const tree = (
  <StrictMode>
    <ReduxProvider store={store}>
      <ThemeProvider>
        <RouterProvider router={Routing} />

        <SnackbarProvider />
      </ThemeProvider>
    </ReduxProvider>
  </StrictMode>
)

/**
 * Render the react application.
 */
root.render(tree)
